
import { format, formatDistance } from 'date-fns';

/**
 * Format a notification date string
 * @param dateString ISO date string
 * @returns Formatted date string
 */
export const formatNotificationDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    
    // For today, show relative time
    const now = new Date();
    if (date.toDateString() === now.toDateString()) {
      return formatDistance(date, now, { addSuffix: true });
    }
    
    // For recent dates (last 7 days), show day of week + time
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    if (date > sevenDaysAgo) {
      return format(date, 'EEEE, h:mm a');
    }
    
    // For older dates, show full date
    return format(date, 'MMM d, yyyy, h:mm a');
  } catch (error) {
    console.error("Error formatting date:", error);
    return dateString; // Return original string if formatting failed
  }
};
